/* Sarah Bohr Publications - cover normaliser
   Book cover mockups arrive with wildly different amounts of built-in white space.
   This measures where the book actually sits inside each image, then scales and
   positions it so every book renders at the same height on a shared baseline.
   Works for any future cover without needing the artwork re-cropped. */
(function () {
  'use strict';

  var BOOK_RATIO = 0.88;   // book height as a fraction of its container
  var SAMPLE = 140;        // px width used for measuring (speed)
  var LIGHT = 243;         // anything brighter than this counts as background

  function cacheGet(src) {
    try { var v = sessionStorage.getItem('sbpcv:' + src); return v ? JSON.parse(v) : null; }
    catch (e) { return null; }
  }
  function cacheSet(src, val) {
    try { sessionStorage.setItem('sbpcv:' + src, JSON.stringify(val)); } catch (e) {}
  }

  function measure(src) {
    return new Promise(function (resolve) {
      var hit = cacheGet(src);
      if (hit) return resolve(hit);

      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onerror = function () { resolve(null); };
      im.onload = function () {
        try {
          var w = SAMPLE;
          var h = Math.max(1, Math.round(im.naturalHeight * SAMPLE / im.naturalWidth));
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(im, 0, 0, w, h);
          var d = ctx.getImageData(0, 0, w, h).data;
          var top = h, bottom = -1;
          for (var y = 0; y < h; y++) {
            for (var x = 0; x < w; x++) {
              var i = (y * w + x) * 4;
              if (d[i + 3] < 12) continue;
              if (d[i] > LIGHT && d[i + 1] > LIGHT && d[i + 2] > LIGHT) continue;
              if (y < top) top = y;
              if (y > bottom) bottom = y;
              break;
            }
            if (bottom === y) continue;
            for (var x2 = w - 1; x2 >= 0; x2--) {
              var j = (y * w + x2) * 4;
              if (d[j + 3] < 12) continue;
              if (d[j] > LIGHT && d[j + 1] > LIGHT && d[j + 2] > LIGHT) continue;
              if (y < top) top = y;
              if (y > bottom) bottom = y;
              break;
            }
          }
          if (bottom < 0 || bottom <= top) return resolve(null);
          var res = { top: top / h, height: (bottom - top + 1) / h, ratio: im.naturalWidth / im.naturalHeight };
          cacheSet(src, res);
          resolve(res);
        } catch (e) { resolve(null); }
      };
      im.src = src;
    });
  }

  function fallback(img) {
    img.style.maxHeight = '100%';
    img.style.width = 'auto';
    img.style.bottom = '0px';
    img.classList.add('sbp-cover-ready');
  }

  async function normalise(img) {
    if (img.dataset.sbpDone) return;
    img.dataset.sbpDone = '1';
    var box = img.parentElement;
    var boxH = box.clientHeight;
    if (!boxH) return fallback(img);

    var m = await measure(img.currentSrc || img.src);
    if (!m || !m.height) return fallback(img);

    // Scale the whole image so the BOOK inside it is BOOK_RATIO of the box height.
    var imgH = (BOOK_RATIO * boxH) / m.height;
    // Push the image down so the bottom of the book lands on the box baseline.
    var below = (1 - (m.top + m.height)) * imgH;

    img.style.height = imgH + 'px';
    img.style.width = 'auto';
    img.style.maxWidth = 'none';
    img.style.bottom = (-below) + 'px';
    img.classList.add('sbp-cover-ready');
  }

  function run() {
    var imgs = document.querySelectorAll('.sbp-cover img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete) normalise(img);
      else img.addEventListener('load', function () { normalise(this); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  window.addEventListener('resize', function () {
    clearTimeout(window.__sbpCvT);
    window.__sbpCvT = setTimeout(function () {
      var imgs = document.querySelectorAll('.sbp-cover img');
      for (var i = 0; i < imgs.length; i++) { imgs[i].dataset.sbpDone = ''; normalise(imgs[i]); }
    }, 180);
  });

  document.addEventListener('shopify:section:load', run);
})();
